<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" id="travelDeclaration" style="text-align: center; padding: 0px">
    <div class="content-body-container col-md-12">
      <div class="backstretch">
        <img v-if="isBigScreenWidth" src="../assets/bg.png" />
        <img v-if="!isBigScreenWidth" src="../assets/mobilebg.jpg" />
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <h4 class="td-default-title">Travel Declaration / 旅行申报表</h4>

        <div style="width: 30%; margin: 0 auto">
          <el-button v-on:click="showTravelDeclarationModal()" type="primary" style="margin: 0 0 10px 0; max-width: 100%">
            Add Declaration | 添加申报表
          </el-button>
        </div>
      </div>

      <div>
        <ul class="timeline" style="margin: 0px" v-if="timelineList.length > 0">
          <li v-for="timeline in timelineList">
            <div class="each-timeline-container">
              <div class="timeline-date">
                {{ convertDatetime(timeline.ParTrvDclFromDate) }}
                <span style="color: #1890ff"> > </span>
                {{ convertDatetime(timeline.ParTrvDclToDate) }}
              </div>

              <div class="each-timeline row" style="margin: 0px">
                <div class="tl-child-container row" v-if="timeline.ParTrvDclBringChild === 'Yes' && childNameList.length > 0">
                  <div class="tl-common-div row" style="margin-bottom: 20px">
                    <span style="color: #46525b; font-weight: 600; display: block">Child | 孩子(们)</span>
                  </div>

                  <div class="tl-common-div row" style="margin-bottom: 20px">
                    <div class="tl-common-div row" style="margin-bottom: 10px" v-if="child.ParTrvDclID === timeline.ParTrvDclID" v-for="child in childNameList">
                      <img
                        v-if="child.Profile_Img !== '-'"
                        :src="`data:` + child.Profile_ImgType + `;base64, ${child.Profile_Img}`"
                        style="width: 40px; height: 40px"
                      />
                      <img v-if="child.Profile_Img === '-'" src="../assets/tdChild.png" style="width: 40px; height: 40px" />

                      <span class="tl-child-name">{{ child.StudentName }}</span>
                    </div>
                  </div>

                  <div class="tl-common-div row" style="align-self: flex-end">
                    <el-button type="danger" style="white-space: normal; padding: 6px 10px" @click="showDeleteTravelDeclarationModal(timeline.ParTrvDclID)">
                      <i class="fa fa-plane" aria-hidden="true" style="margin-right: 5px"></i>
                      <span>Cancel Trip / 取消行程</span>
                    </el-button>
                  </div>
                </div>

                <div class="tl-content-container row" :class="timeline.ParTrvDclBringChild === 'Yes' && childNameList.length > 0 ? 'left' : 'full'">
                  <div class="tl-common-div row" style="margin-bottom: 20px">
                    <div class="tl-content-declared">
                      <div>
                        <span style="color: #7c8799">Declared By / 申报者:</span>
                        <span style="margin-left: 5px; color: #1890ff">{{ timeline.CreatedByName }}</span>
                      </div>

                      <div v-if="timeline.ParTrvDclBringChild === 'No'">
                        <span style="color: rgba(0, 0, 0, 0.85); font-weight: 600">Not traveling overseas | 没有出国</span>
                      </div>
                    </div>

                    <div style="width: 40%; margin-left: auto; text-align: right" v-if="timeline.ParTrvDclBringChild === 'No'">
                      <el-button type="danger" style="white-space: normal" @click="showDeleteTravelDeclarationModal(timeline.ParTrvDclID)">
                        <i class="fa fa-plane" aria-hidden="true" style="margin-right: 5px"></i>
                        <span>Cancel Trip / 取消行程</span>
                      </el-button>
                    </div>
                  </div>

                  <div
                    class="tl-common-div row"
                    v-if="timeline.ParTrvDclCountry"
                    style="margin-bottom: 20px; background: #f0f0f0; border-radius: 4px; padding: 15px"
                  >
                    <div style="width: 30%" v-if="timeline.ParTrvDclTransCountry">
                      <span style="color: rgba(0, 0, 0, 0.85); font-size: 12px">Transit | 过境</span>
                      <span style="color: rgba(0, 0, 0, 0.85); font-weight: 600">
                        {{ timeline.ParTrvDclTransCountry }} ({{ timeline.ParTrvDclTransCity }})
                      </span>
                    </div>

                    <div v-if="timeline.ParTrvDclTransCountry" style="width: 3%; margin: 20px 15px 20px 0px">
                      <span style="color: #1890ff"> > </span>
                    </div>

                    <div style="width: 30%" v-if="timeline.ParTrvDclCountry">
                      <span style="color: rgba(0, 0, 0, 0.85); font-size: 12px">Destination | 国家</span>
                      <span style="color: rgba(0, 0, 0, 0.85); font-weight: 600">
                        {{ timeline.ParTrvDclCountry }} <span v-if="timeline.ParTrvDclCity">({{ timeline.ParTrvDclCity }})</span>
                      </span>
                    </div>

                    <div style="width: 30%; margin-left: auto; text-align: center" v-if="timeline.ParTrvDclTransCountry">
                      <span style="color: #1890ff; font-weight: 600" v-if="!isNull(timeline.ParTrvDclTransDate)">
                        {{ convertDatetime(timeline.ParTrvDclTransDate) }}
                      </span>
                      <span v-else>-</span>
                      <span style="color: #7c8799; font-size: 12px">Date of transit | 过境日期</span>
                    </div>
                  </div>

                  <hr style="width: 100%; margin: 0px 0px 20px 0px" v-if="timeline.ParTrvDclRelLeaveEndDate" />

                  <div class="tl-common-div row" style="margin-bottom: 20px" v-if="timeline.ParTrvDclRelLeaveEndDate">
                    <div style="width: 70%">
                      <span style="color: #7c8799; display: block">Last date of close contact with LOA/HQO/SHN immediate family and friends</span>
                      <span style="color: #7c8799; display: block">与LOA/HQO/SHN 的家属或朋友有过密切接触的最后一天</span>
                    </div>

                    <div class="tl-content-lastdate" style="margin-left: auto; text-align: right">
                      <span style="color: #1890ff; font-weight: 600">{{ convertDatetime(timeline.ParTrvDclRelLeaveEndDate) }}</span>
                    </div>
                  </div>

                  <hr style="width: 100%; margin: 0px 0px 20px 0px" />

                  <div class="tl-common-div row" v-if="timeline.ParTrvDclRemark">
                    <span style="color: #7c8799">Remarks / 备注:</span>
                    <span style="color: rgba(0, 0, 0, 0.8); margin-left: 10px; white-space: pre-line">{{ timeline.ParTrvDclRemark }}</span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <ul class="timeline" v-if="timelineList.length === 0">
          <li>
            <div style="padding: 20px">
              <p style="margin-bottom: 0px">No travel declaration found.<br />没有旅行申报。</p>
            </div>

            <div style="padding: 20px">
              <p style="margin-bottom: 0px">A new travel declaration is required.<br />即使没有计划出国，也需要添加旅行申报。</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="display: none">
        <h4 style="padding: 15px 25px">Travel Declaration / 旅行申报表</h4>
        <el-button v-on:click="showTravelDeclarationModal()" type="primary" icon="el-icon-edit" style="margin: 0 0 10px 0; width: 100%">
          Add Declaration / 添加申报表
        </el-button>
      </div>

      <!--            style="display: inline-block;"-->
      <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8" style="display: none">
        <ul class="timeline" v-if="timelineList.length > 0">
          <!-- show the declaration list -->
          <li v-for="timeline in timelineList">
            <div style="padding: 20px">
              <div class="english-version-container">
                <p style="margin-bottom: 0px">Declared By / 申报者 : {{ timeline.CreatedByName }}</p>
                <div v-if="timeline.ParTrvDclBringChild === 'Yes' && childNameList.length > 0" style="display: inline-block">
                  <span>Child / 孩子(们) : </span>
                  <br />
                  <div
                    class=""
                    v-if="child.ParTrvDclID === timeline.ParTrvDclID"
                    v-for="child in childNameList"
                    style="display: inline-block; margin-left: 25px"
                  >
                    <img
                      v-if="child.Profile_Img !== '-'"
                      :src="`data:` + child.Profile_ImgType + `;base64, ${child.Profile_Img}`"
                      style="width: 60px; height: 80px"
                    />
                    <img v-if="child.Profile_Img === '-'" src="../assets/boy.png" style="width: 60px; height: 80px" />
                    <br />
                    <span style="text-align: center">{{ child.StudentName }}</span>
                  </div>
                </div>
                <div v-if="timeline.ParTrvDclBringChild === 'No'" style="display: inline-block">Not traveling overseas / 没有出国</div>
                <!--                            <p style="margin-bottom: 0px;" v-if="childNameList.length > 0">-->
                <!--                                Child :-->
                <!--                                <span v-if="child.ParTrvDclID === timeline.ParTrvDclID" v-for="child in childNameList">-->

                <!--                                    {{child.StudentName}},-->
                <!--                                </span>-->
                <!--                            </p>-->
                <p style="margin-bottom: 0px">
                  From / 从 {{ convertDatetime(timeline.ParTrvDclFromDate) }} to / 至 {{ convertDatetime(timeline.ParTrvDclToDate) }}
                </p>
                <p style="margin-bottom: 0px" v-if="timeline.ParTrvDclTransCountry">
                  Transit / 过境 : {{ timeline.ParTrvDclTransCountry }} ({{ timeline.ParTrvDclTransCity }}) <br />Destination / 国家 :
                  {{ timeline.ParTrvDclCountry }} ({{ timeline.ParTrvDclCity }}) <br />Date of transit / 过境日期 :
                  <span v-if="!isNull(timeline.ParTrvDclTransDate)">{{ convertDatetime(timeline.ParTrvDclTransDate) }}</span
                  ><span v-else>-</span>
                </p>
                <p style="margin-bottom: 0px" v-if="timeline.ParTrvDclCountry && !timeline.ParTrvDclTransCountry">
                  Travel to / 前往 {{ timeline.ParTrvDclCountry }} ({{ timeline.ParTrvDclCity }})
                </p>
                <p style="margin-bottom: 0px" v-if="timeline.ParTrvDclRelLeaveEndDate">
                  Last date of close contact with LOA/HQO/SHN immediate family and friends / 与LOA/HQO/SHN 的家属或朋友有过密切接触的最后一天 :
                  {{ convertDatetime(timeline.ParTrvDclRelLeaveEndDate) }}
                </p>
                <p v-if="timeline.ParTrvDclRemark">Remarks / 备注 : {{ timeline.ParTrvDclRemark }}</p>
              </div>

              <el-button type="danger" @click="showDeleteTravelDeclarationModal(timeline.ParTrvDclID)">
                <i class="fa fa-plane" aria-hidden="true" style="margin-right: 5px"></i>
                <span>Cancel Trip / 取消行程</span>
              </el-button>
            </div>
          </li>
        </ul>

        <ul class="timeline" v-if="timelineList.length === 0">
          <li>
            <div style="padding: 20px">
              <p style="margin-bottom: 0px">No travel declaration found.<br />没有旅行申报。</p>
            </div>

            <div style="padding: 20px">
              <p style="margin-bottom: 0px">A new travel declaration is required.<br />即使没有计划出国，也需要添加旅行申报。</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <b-modal
      id="TravelDeclarationModal"
      size="lg"
      title="Add Declaration / 添加申报表"
      ok-only
      ok-variant="secondary"
      hide-footer
      ref="showTravelDeclarationModal"
      @hide="hideTravelDeclarationModal()"
    >
      <div class="row form-group__wrapper">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label
            >Did you / are you intending to bring your child overseas from 1 Jan 2022 to 31 Dec 2022?<br />
            您与您的孩子是否打算在1 Jan 2022 至31 Dec 2022期间出国？
          </label>
          <select v-model="travelOverseas" class="form-control pro-edt-select form-control-primary" @change="changeTravelOverseas">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>

        <div v-if="travelOverseas" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Date of travel<br />旅行日期</label>
          <div class="date">
            <el-date-picker
              v-model="declareDate"
              type="daterange"
              range-separator="TO"
              start-placeholder="From Date"
              end-placeholder="To Date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              :picker-options="datePicker"
              style="max-width: 100%"
            >
            </el-date-picker>
          </div>
        </div>

        <div v-if="travelOverseas" class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="margin: 10px 0px 20px 0px">
          <label>Which child will you bring to overseas?<br />您将带哪位孩子出国？</label>
          <el-checkbox-group v-model="studentCheckList">
            <el-checkbox
              :value="stud.StudentID"
              :label="stud.StudentFirstName + ' ' + stud.StudentMiddleName + ' ' + stud.StudentLastName"
              v-for="stud in studentsInfo"
              style="display: inline-block !important"
              @change="selectChild($event, stud)"
            ></el-checkbox>
          </el-checkbox-group>
        </div>

        <div v-if="travelOverseas" class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: 10px 0px 20px 0px">
          <el-checkbox-group v-model="cruiseToNoWhere">
            <el-checkbox label="Cruise To NoWhere" style="display: inline-block !important"></el-checkbox>
          </el-checkbox-group>
        </div>

        <hr />

        <div v-if="travelOverseas && !cruiseToNoWhere" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Where is your family going on vacation?<br />您与您的孩子要去哪里度假呢？</label>
          <country-select class="form-control pro-edt-select form-control-primary" v-model="country" :country="country" :countryName="true" />
        </div>

        <div v-if="travelOverseas && !cruiseToNoWhere" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label v-if="country == ''">Which city will your family be visiting?<br />您与您的孩子要去哪个城市呢？</label>
          <label v-if="country !== ''">Which city in {{ country }} will your family be visiting?<br />您的家人会去{{ country }}的哪个城市？</label>
          <input type="text" class="form-control form-control-primary" placeholder="City" v-model="region" />
          <!-- region-select class="form-control pro-edt-select form-control-primary" placeholder="Select City" v-model="region" :country="country" :region="region" :countryName="true" :regionName="true" / -->
        </div>

        <div v-if="travelOverseas && !cruiseToNoWhere" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Will you be transiting at any other countries?<br />您与您的孩子会在其他国家过境吗？</label>
          <select v-model="transiting" class="form-control pro-edt-select form-control-primary" @change="changeTransiting">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>

        <div v-if="travelOverseas && !cruiseToNoWhere && transiting" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Please let us know which country your family will be transiting at?<br />你们将在哪个国家过境呢?</label>
          <country-select class="form-control pro-edt-select form-control-primary" v-model="transitCountry" :country="transitCountry" :countryName="true" />
        </div>

        <div v-if="travelOverseas && !cruiseToNoWhere && transiting" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label v-if="transitCountry == ''">Which city will your family be transiting?<br />你们将在哪个城市过境？</label>
          <label v-if="transitCountry !== ''"
            >Which city in {{ transitCountry }} will your family be transiting?<br />您的家人将在{{ transitCountry }}哪个城市过境呢？</label
          >
          <input type="text" class="form-control form-control-primary" placeholder="City" v-model="transitRegion" />
          <!-- region-select class="form-control pro-edt-select form-control-primary" placeholder="Select City" v-model="transitRegion" :country="transitCountry" :region="transitRegion" :countryName="true" :regionName="true" / -->
        </div>

        <div v-if="travelOverseas && !cruiseToNoWhere && transiting" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Please let us know the date of transit<br />请告知我们转机日期</label>
          <el-date-picker v-model="transitingDate" type="date" placeholder="Pick a Date" format="dd/MM/yyyy" value-format="dd/MM/yyyy" style="max-width: 100%">
            <!-- :picker-options="datePicker" -->
          </el-date-picker>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label
            >Did your child come into close contact with immediate family & friends living/visiting who travelled to overseas OR with anyone on Leave of Absence
            (LOA), Home Quarantine Order (HQO), Stay at Home Notice (SHN) issued by MOH in the last 14 days?</label
          >
          <label>在过去14天内，您的孩子是否与以下人员及其家属或朋友有过密切接触？</label>
          <label>- 去过出国旅游</label>
          <label>- 或拿缺席假 (LOA)、隔离令(HQO)或家居隔离(SHN)令</label>

          <select v-model="travelRelatedCountry" class="form-control pro-edt-select form-control-primary" @change="changeTravelRelatedCountry">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>

        <div v-if="travelRelatedCountry" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label
            >When did your child last come into contact with this person(s)/when will the last date of contact with this person be? OR What is the last date of
            the person(s) LOA/HQO/SHN?</label
          >
          <label>请问您和您的孩子最后与以上所述之人接触是或会是什么时候？请问以上所述之人缺席假 (LOA)、隔离令(HQO)或家居隔离(SHN)的最后一天是什么时候？</label>

          <el-date-picker
            v-model="travelRelatedCountryLastDate"
            type="date"
            placeholder="Pick a Date"
            format="dd/MM/yyyy"
            value-format="dd/MM/yyyy"
            style="max-width: 100%"
          >
            <!-- :picker-options="datePicker" -->
          </el-date-picker>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Remarks<br />备注</label>
          <!--                        <vs-textarea v-model="remarks" rows="4" maxlength="3000" placeholder="Please input remarks"></vs-textarea>-->
          <el-input v-model="remarks" type="textarea" :rows="6" maxlength="3000" placeholder="Please input remarks / 请填写备注"></el-input>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: 20px 0 0 0">
          <el-button type="default" @click="hideTravelDeclarationModal()">{{ lang('Cancel') }} / 取消</el-button>
          <el-button type="primary" style="float: right" @click="saveDeclaration()">{{ lang('Add') }} / 添加</el-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="DeleteTravelDeclarationModal"
      size="lg"
      title="Confirmation of cancellation / 取消确认"
      ref="showDeleteTravelDeclarationModal"
      centered
      :ok-title="lang('Confirm') + '/ 确认'"
      @ok="deleteDeclaration()"
      :cancel-title="lang('Cancel') + '/ 取消'"
      @hide="hideDeleteTravelDeclarationModal()"
      @cancel="hideDeleteTravelDeclarationModal()"
      hide-footer
    >
      <div class="form-group">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h5>Are you sure you would like to cancel this trip?<br />您确定要取消此行吗？</h5>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Reason<br />理由</label>
          <!--                    <i class="fa fa-plane" aria-hidden="true" style="margin-right: 5px;"></i>-->
          <el-select v-model="ddlCancelTrip">
            <el-option v-for="(item, iKey) in ddlCancelTripList" :key="iKey" :label="item.label" :value="item.label" placeholder="Select Reason"></el-option>
          </el-select>
        </div>

        <div v-if="ddlCancelTrip === 'Others'" class="delete-declaration-remarks-container col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Remarks<br />备注</label>
          <el-input v-model="deleteRemarks" type="textarea" :rows="6" maxlength="3000" placeholder="Please input remarks / 请填写备注"></el-input>
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: 20px 0 0 0">
        <el-button type="default" @click="hideDeleteTravelDeclarationModal()">{{ lang('Cancel') }} / 取消</el-button>
        <el-button type="primary" style="float: right" @click="deleteDeclaration()">{{ lang('Confirm') }} / 确认</el-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import vueCountryRegionSelect from 'vue-country-region-select'

import Vue from 'vue'
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import moment from 'moment'
import { lang } from '../locale/index'

Vue.use(vueCountryRegionSelect)
export default {
  name: 'ParentTravelDeclaration',
  components: {},
  data() {
    return {
      varDateVal: '',
      declaration: {},
      declareDate: [],
      travelOverseas: false,
      transiting: false,
      travelRelatedCountry: false,
      country: '',
      region: '',
      transitingDate: '',
      transitCountry: '',
      transitRegion: '',
      travelRelatedCountryLastDate: '',
      remarks: '',
      studentCheckList: [],
      studentsInfo: [],
      selectedStudentIDs: [],
      timelineList: [],
      childNameList: [],
      parentName: '',
      travelDclID: '',
      deleteRemarks: '',
      isBigScreenWidth: true,
      ddlCancelTrip: '',
      ddlCancelTripList: [
        {
          prop: 'TripCancelled',
          label: 'Trip Cancelled',
        },
        {
          prop: 'TripPostponed',
          label: 'Trip Postponed',
        },
        {
          prop: 'WrongInput',
          label: 'Wrong Input',
        },
        {
          prop: 'Others',
          label: 'Others',
        },
      ],
      datePicker: {
        disabledDate(date) {
          return date < new Date().getTime() - 20 * 24 * 60 * 60 * 1000
          //  Without using the second variable, you can replace 7 for with your back x days:
          //e.g return date< Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
        },
      },

      schoolID: '',
      parentSchIds: [],
      cruiseToNoWhere: false,
    }
  },
  mounted() {
    this.isMobile()

    if (Cookies.get('userTypeSession') === 'Parent') {
      this.loadParentInfo()
      this.loadAllTimelineList()
      this.varDateVal = moment().add(-14, 'days').format('DD MMM', new Date())
      this.parentName = Cookies.get('userNameSession')

      this.schoolID = Cookies.get('schoolSession')
      this.schoolIDs = JSON.parse(this.schoolID)
      this.schoolIDs = this.schoolIDs.Table

      this.parentSchIds = []
      this.schoolIDs.forEach((object, index) => {
        this.parentSchIds.push(object.SCH_Ids)
      })
    }

    $(document).ready(function () {
      $('.content-body-container').css('min-height', window.outerHeight)
    })
  },
  methods: {
    lang,

    showTravelDeclarationModal() {
      this.$refs.showTravelDeclarationModal.show()
    },

    hideTravelDeclarationModal() {
      this.$refs.showTravelDeclarationModal.hide()
      this.clearAllField()
    },

    showDeleteTravelDeclarationModal(declarationID) {
      this.$refs.showDeleteTravelDeclarationModal.show()
      this.travelDclID = ''
      this.travelDclID = declarationID
    },

    hideDeleteTravelDeclarationModal() {
      this.$refs.showDeleteTravelDeclarationModal.hide()
      this.travelDclID = ''
      this.ddlCancelTrip = ''
      this.deleteRemarks = ''
    },

    changeTravelOverseas(val) {
      if (val.target.value === 'true') {
        this.travelOverseas = true
      } else {
        this.travelOverseas = false

        this.clearAllField()
      }
    },

    selectChild(event, student) {
      if (event) {
        this.selectedStudentIDs.push(student.StudentID)
      } else {
        this.selectedStudentIDs = this.selectedStudentIDs.filter(d => {
          return d !== student.StudentID
        })
      }
    },

    changeTransiting(val) {
      if (val.target.value === 'true') {
        this.transiting = true
      } else {
        this.transiting = false

        this.transitCountry = ''
        this.transitRegion = ''
        this.transitingDate = ''
        this.travelRelatedCountry = false
        this.travelRelatedCountryLastDate = ''
      }
    },

    changeTravelRelatedCountry(val) {
      if (val.target.value === 'true') {
        this.travelRelatedCountry = true
      } else {
        this.travelRelatedCountry = false

        this.travelRelatedCountryLastDate = ''
      }
    },

    async loadParentInfo() {
      // this.$vs.loading();
      try {
        if (Cookies.get('userIDSession') !== null || Cookies.get('userIDSession') !== undefined) {
          const response = await DataSource.shared.getParentStudentsInfo(Cookies.get('userIDSession'))

          if (response) {
            if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'No record found',
              })
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Please try again later',
              })
            } else {
              this.studentsInfo = response.Students.filter(stud => {
                // return stud.StudentLevel !== "";
                return stud.StudentCourseStatus !== 'Closed'
              })
              // this.$vs.loading.close();
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async saveDeclaration() {
      try {
        if (this.travelOverseas && this.isNull(this.declareDate)) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select date.',
          })

          return
        }

        if (this.travelOverseas && this.isNull(this.selectedStudentIDs)) {
          this.$notify.error({
            title: 'Error',
            message: 'Please let us know which child(ren) is travelling.',
          })

          return
        }

        if (!this.cruiseToNoWhere) {
          if (this.travelOverseas && this.isNull(this.country)) {
            this.$notify.error({
              title: 'Error',
              message: 'Please select country.',
            })

            return
          }

          if (this.travelOverseas && this.isNull(this.region)) {
            this.$notify.error({
              title: 'Error',
              message: 'Please input city.',
            })

            return
          }

          if (this.transiting && this.isNull(this.transitCountry)) {
            this.$notify.error({
              title: 'Error',
              message: 'Please select transit country.',
            })

            return
          }

          if (this.transiting && this.isNull(this.transitRegion)) {
            this.$notify.error({
              title: 'Error',
              message: 'Please input transit city.',
            })

            return
          }

          if (this.transiting && this.isNull(this.transitingDate)) {
            this.$notify.error({
              title: 'Error',
              message: 'Please select transit date.',
            })

            return
          }
        }

        if (this.travelRelatedCountry && this.isNull(this.travelRelatedCountryLastDate)) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select the last date of the person(s) LOA/HQO/SHN.',
          })

          return
        }

        let isTravelOverseas = ''
        if (this.travelOverseas) {
          isTravelOverseas = 'Yes'
        } else {
          isTravelOverseas = 'No'
          this.declareDate = []
          this.declareDate.push(moment().format('DD/MM/YYYY'), '31/12/2022')
        }

        let isTransiting = ''
        if (this.transiting) {
          isTransiting = 'Yes'
        } else {
          isTransiting = 'No'
        }

        let isTravelRelatedCountry = ''
        if (this.travelRelatedCountry) {
          isTravelRelatedCountry = 'Yes'
        } else {
          isTravelRelatedCountry = 'No'
        }

        let selectedIds = ''
        this.selectedStudentIDs.forEach(d => {
          if (selectedIds === '') {
            selectedIds = d
          } else {
            selectedIds += ',' + d
          }
        })

        this.$vs.loading()

        let jsonDetailsItem = {}
        jsonDetailsItem.StudentID = selectedIds
        jsonDetailsItem.FromDate = this.declareDate[0]
        jsonDetailsItem.ToDate = this.declareDate[1]
        jsonDetailsItem.BringChild = isTravelOverseas
        if (!this.cruiseToNoWhere) {
          jsonDetailsItem.Country = this.country
          jsonDetailsItem.City = this.region
          jsonDetailsItem.Transiting = isTransiting
          jsonDetailsItem.TransitingCountry = this.transitCountry
          jsonDetailsItem.TransitingCity = this.transitRegion
          jsonDetailsItem.TransitingDate = this.transitingDate
        } else {
          jsonDetailsItem.Country = 'cruise to nowhere'
        }
        // jsonDetailsItem.Country = this.country;
        // jsonDetailsItem.City = this.region;
        // jsonDetailsItem.Transiting = isTransiting;
        // jsonDetailsItem.TransitingCountry = this.transitCountry;
        // jsonDetailsItem.TransitingCity = this.transitRegion;
        // jsonDetailsItem.TransitingDate = this.transitingDate;
        jsonDetailsItem.Remark = this.remarks
        jsonDetailsItem.RelatedLeave = isTravelRelatedCountry
        jsonDetailsItem.RelatedLeaveEndDate = this.travelRelatedCountryLastDate

        const response = await DataSource.shared.saveTravelDeclaration(JSON.stringify(jsonDetailsItem))
        // const response = await DataSource.shared.saveTravelDeclaration(this.declareDate[0], this.declareDate[1], isTravelOverseas,
        //     JSON.stringify(this.selectedStudentIDs), this.country, this.region, isTransiting, this.transitCountry, this.transitRegion,
        //     this.remarks);

        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Please try again later',
            })
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'This date range has been declared before. Please select another date.',
            })
          } else {
            this.loadAllTimelineList()
            this.hideTravelDeclarationModal()
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        console.log(e, 'Save error msg.')
      }
    },

    async loadAllTimelineList() {
      this.$vs.loading()
      try {
        if (Cookies.get('userIDSession') !== null || Cookies.get('userIDSession') !== undefined) {
          const response = await DataSource.shared.getTravelDeclaration(Cookies.get('userIDSession'))

          if (response) {
            if (response.code === '2') {
              // this.$notify.error({
              //     title: 'Error',
              //     message: 'No record found'
              // });
              this.timelineList = []
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Please try again later',
              })
            } else {
              this.timelineList = response.ParentTravelDeclaration.Table
              this.childNameList = response.ParentTravelDeclarationStudents.Table

              // this.timelineList.forEach(timeline => {
              //     this.childNameList.forEach(child => {
              //
              //     });
              // });
            }
            this.$vs.loading.close()
          }

          if (this.timelineList.length <= 0) {
            this.showTravelDeclarationModal()
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async deleteDeclaration() {
      try {
        if (this.ddlCancelTrip === '') {
          this.$notify.error({
            title: 'Error',
            message: 'Please select reason.',
          })

          return
        }

        if (this.ddlCancelTrip === 'Others' && this.deleteRemarks === '') {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in the remark.',
          })

          return
        } else {
          this.deleteRemarks = this.ddlCancelTrip
        }

        const response = await DataSource.shared.deleteTravelDeclaration(this.travelDclID, 'Delete', this.deleteRemarks)

        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Please try again later',
            })
          } else {
            this.hideDeleteTravelDeclarationModal()
            this.loadAllTimelineList()
          }
        }
      } catch (e) {
        console.log(e, 'Delete error msg.')
      }
    },

    convertDatetime(val) {
      return moment(val).format('DD MMM YYYY')
    },

    clearAllField() {
      this.declareDate = []
      this.travelOverseas = false
      this.transiting = false
      this.travelRelatedCountry = false
      this.country = ''
      this.region = ''
      this.transitCountry = ''
      this.transitRegion = ''
      this.transitingDate = ''
      this.travelRelatedCountryLastDate = ''
      this.remarks = ''
      this.selectedStudentIDs = []
      this.studentCheckList = []
      this.cruiseToNoWhere = false
    },

    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0
    },

    isMobile() {
      if (window.innerWidth <= 760) {
        this.isBigScreenWidth = false
      } else {
        this.isBigScreenWidth = true
      }
    },
  },
  created() {
    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
}
</script>

<style scoped>
.content-body-container {
  display: inline-block;
  padding: 20px;
  background: white;
}

#travelDeclaration .backstretch {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /*position: fixed;*/
  position: absolute;
}

#travelDeclaration .backstretch img {
  height: 100%;
  width: 100%;
}

.td-default-title {
  color: #485560;
  padding: 15px 25px;
  font-size: 21px;
}

.modal-dialog .form-control {
  padding: 0.375rem 0.75rem;
}

ul.timeline {
  list-style-type: none;
  position: relative;
}
ul.timeline:before {
  content: '';
  /*background: #d4d9df;*/
  display: inline-block;
  position: absolute;
  /*left: 29px;*/
  left: 50%;
  width: 2px;
  height: 100%;
  z-index: 400;
  border: 1px dashed #b7bac9;
}
ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}
ul.timeline > li:before {
  content: '';
  /*background: white;*/
  background: #1890ff;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  /*border: 3px solid #22c0e8;*/
  /*left: 20px;*/
  /*left: 50%;*/
  width: 20px;
  height: 20px;
  z-index: 9;
  margin-left: -19px;
}

.each-timeline-container {
  width: 45%;
  position: relative;
}

.timeline li:nth-child(odd) .each-timeline-container {
  margin-right: auto;
}

.timeline li:nth-child(even) .each-timeline-container {
  margin-left: auto;
  left: -2%;
}

.timeline-date {
  color: #485560;
  font-size: 16px;
  margin-bottom: 10px;
}

.timeline li:nth-child(odd) .timeline-date {
  text-align: right;
}

.timeline li:nth-child(even) .timeline-date {
  text-align: left;
}

.each-timeline {
  background: #ffffff;
  border-radius: 5px;
  padding: 20px;
  text-align: left;
}

.tl-child-container {
  width: 30%;
  margin: 0px;
  padding-right: 20px;
  border-right: 1px solid #eceded;
}

.tl-child-name {
  width: 65%;
  margin-left: auto;
}

.tl-content-container.left {
  width: 70%;
  margin: 0px;
  padding-left: 20px;
}

.tl-content-container.full {
  width: 100%;
  margin: 0px;
}

.tl-content-container.full .tl-content-declared {
  width: 50%;
}

.tl-content-container.left .tl-content-declared {
  width: 100%;
}

.tl-content-container.full .tl-content-lastdate {
  width: 20%;
}

.tl-content-container.left .tl-content-lastdate {
  width: 25%;
}

.tl-common-div {
  width: 100%;
  margin: 0px;
}
</style>

<style>
#TravelDeclarationModal .el-date-editor .el-range-separator {
  width: auto;
}

.travelDeclarationPublic #main-content {
  padding: 0px;
}

.travelDeclarationPublic .topbar {
  /*position: sticky;*/
  top: 0px;
}
</style>
